import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useState } from "react";

type EnqueueSnackbarOptions = {};
type EnqueueSnackbarType = {
    key?: number;
    active?: boolean;
    done?: boolean;
    message?: React.ReactNode;
    options?: EnqueueSnackbarOptions;
};

type SnackbarContextType = {
    enqueueSnackbars: Array<EnqueueSnackbarType>;
    enqueueSnackbar: (message: React.ReactNode, options?: EnqueueSnackbarOptions) => number;
    destroySnackbar: (key: number, done?: boolean) => void;
};
const SnackbarContext: Context<SnackbarContextType | null> = createContext<SnackbarContextType | null>(null);

export const SnackbarProvider = ({ children }: PropsWithChildren<{}>) => {
    const [enqueueSnackbars, setEnqueueSnackbars] = useState<Array<EnqueueSnackbarType>>([
        // { active: true, message: "test", key: 1234 },
    ]);
    const enqueueSnackbarCallback = useCallback((message: React.ReactNode, options?: EnqueueSnackbarOptions) => {
        const key = Math.floor(100000000 + Math.random() * 900000000);
        setEnqueueSnackbars((prev) => [...prev, { active: true, key, message, options }]);
        return key;
    }, []);

    const destroySnackbarCallback = useCallback(
        (key: number, done?: boolean) => {
            const inactiveEnqueue = () =>
                setEnqueueSnackbars((prev) => prev.map((p) => ({ ...p, active: p.key !== key })));
            if (done) setEnqueueSnackbars((prev) => prev.map((p) => ({ ...p, done: p.key === key })));
            setTimeout(() => inactiveEnqueue(), done ? 1000 : 0);
            setTimeout(() => {
                setEnqueueSnackbars((prev) => [...prev.filter((p) => p.key !== key)]);
            }, 2000);
        },
        [setEnqueueSnackbars]
    );
    return (
        <SnackbarContext.Provider
            value={{
                enqueueSnackbars,
                enqueueSnackbar: enqueueSnackbarCallback,
                destroySnackbar: destroySnackbarCallback,
            }}
        >
            {children}
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) throw new Error("Snackbar Hooks must be used within Provider");
    return context;
};
